// Stock profile pictures of the brand (brands/<brand>/assets/avatars/*.webp, the
// backend validates against the same files). users.avatar is one of their names
// ("PF_3"), or an upload the API sends as avatar_url.
const files = import.meta.glob('@brand/assets/avatars/*.webp', { eager: true, import: 'default' })

const byNumber = (a, b) => a.localeCompare(b, undefined, { numeric: true })

export const stockAvatars = Object.entries(files)
  .map(([path, src]) => ({ name: path.split('/').pop().replace(/\.webp$/, ''), src }))
  .sort((a, b) => byNumber(a.name, b.name))

const srcByName = Object.fromEntries(stockAvatars.map(({ name, src }) => [name, src]))

/** Picture URL of a user, or null (then show initials) */
export const avatarSrc = (user) => user?.avatar_url || srcByName[user?.avatar] || null
